import { useCallback } from 'react'

import type { Quote } from '@fv/client-types'
import type { ExchangeRateMap, Workflow } from '@fv/models'
import { quoteUtils } from '@fv/models/core'

import { usePermissions } from '@/features/auth/hooks'

import { useUserMarkup } from './settings/useUserSettings'

export const useRateModifier = () => {
  const markup = useUserMarkup()

  return (quote: Quote, workflow: Workflow, exchangeRates?: ExchangeRateMap) =>
    quoteUtils.applyMarkup(quote, markup?.[workflow], exchangeRates)
}

const useMaskQuotes = () => {
  const { canViewRates } = usePermissions()
  return useCallback(
    (quotes: Quote[]) => {
      if (canViewRates) return quotes
      const minQuote = Math.min(
        ...quotes.filter(q => q.status === 'active').map(q => q.amount),
      )
      return quotes.map(q => ({
        ...q,
        amount: q.amount - minQuote,
      }))
    },
    [canViewRates],
  )
}

export const useQuoteProcessor = () => {
  const markup = useUserMarkup()
  const maskQuotes = useMaskQuotes()

  return useCallback(
    (quotes: Quote[], workflow: Workflow, exchangeRates?: ExchangeRateMap) =>
      maskQuotes(quotes).map(quote =>
        quoteUtils.applyMarkup(quote, markup?.[workflow], exchangeRates),
      ),
    [maskQuotes, markup],
  )
}
